document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-quick-add]');
  if (!btn || btn.disabled) return;

  e.preventDefault();

  var variantId = btn.dataset.variantId;
  var productId = btn.dataset.productId;
  var title     = btn.dataset.productTitle;
  var price     = parseInt(btn.dataset.productPrice, 10) / 100;
  var brand     = btn.dataset.productBrand;
  var category  = btn.dataset.productCategory;
  var originalText = btn.textContent.trim();

  btn.disabled = true;
  btn.textContent = 'Ajout…';

  // --- Ajout via XMLHttpRequest pour que Hextom Shipping Bar l'intercepte ---
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js', true);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Accept', 'application/json');

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {

      // ---- dataLayer GroPulse / GTM ----
      window.groPulseGTMDatalayer = window.groPulseGTMDatalayer || [];
      window.groPulseGTMDatalayer.push({ ecommerce: null });
      window.groPulseGTMDatalayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'EUR',
          value: price,
          items: [{
            item_id: 'shopify_FR_' + productId + '_' + variantId,
            item_name: title, item_brand: brand, item_category: category,
            item_variant: variantId, price: price, quantity: 1
          }]
        }
      });

      // Récupère le panier à jour
      fetch(window.theme.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res) { return res.json(); })
      .then(function(cart) {

        // Prévient Pipeline (header + drawer)
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart }, bubbles: true
        }));

        // Ouvre le drawer nativement
        var drawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (drawer) {
          drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        }

        btn.textContent = '✓ Ajouté';
        setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 1500);
      });

    } else {
      btn.textContent = 'Erreur';
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2500);
    }
  };

  xhr.onerror = function () {
    console.error('Quick add error');
    btn.textContent = 'Erreur';
    setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2500);
  };

  xhr.send(JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }));
});